import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import {
  updateSelectedIncident,
  archiveIncidentById,
  fetchIncidents,
} from 'store/entities/incidents/incidentsThunk';
import { updateIncident } from 'store/entities/incidents/incidentsSlice';
import { selectIncidents } from 'store/selectors';
import { SubmitHandler } from 'react-hook-form';
import { FormAction, QueryState } from 'common/enums';
import { IIncident } from 'interfaces/incident.interface';
import useIncidentForm from '../IncidentsManage/hooks/useIncidentForm';
import { IncidentDetailsProps } from './IncidentDetails.props';
import { IncidentsManageProps } from '../IncidentsManage/IncidentsManage.props';
import IncidentDetailsView from './IncidentDetails.view';
import { isObject } from 'lodash';
import { ApiIncidentManageFilters } from 'services/incidentsEndPoints';

const IncidentDetails: React.FC<IncidentsManageProps> = (props) => {
  const form = useIncidentForm();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { pageLimit, state, selectIncident } = useAppSelector(selectIncidents);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [formStatus, setFormStatus] = useState<FormAction>(FormAction.UPDATE);
  const loading = state === QueryState.AWAIT;
  const handleEditModal = props.handleEditModal;

  useEffect(() => {
    if (selectIncident) {
      form.reset({
        ...selectIncident,
      });
    } else {
      form.reset();
    }
  }, []); // eslint-disable-line

  const handleArchive = async (confirm: boolean) => {
    console.log('confirm archive:', confirm);
    setFormStatus(FormAction.ARCHIVE);
    if (!confirm) return setConfirmModal(false);

    const formData = form.getValues();
    if (formData.id) {
      await dispatch(archiveIncidentById(formData.id))
        .unwrap()
        .then(() => {
          setConfirmModal(false);
          //navigate(-1);
        });
      const filters: ApiIncidentManageFilters = {
        keyword: '',
        limit: pageLimit,
        offset: 1,
      };
      dispatch(fetchIncidents(filters));
      props.handleEditModal(false);
    }
  };

  const onSubmit: SubmitHandler<IIncident> = async (data) => {
    setFormStatus(FormAction.UPDATE);
    const putValue = {
      id: data.id,
      name: data.name,
      description: data.description,
      status: data.status,
      date: data.date,
      deleted: data.deleted,
      archived: data.archived,
    };

    if (data.id && data.id.length) {
      const payload = {
        data: putValue,
        id: data.id,
      };

      await dispatch(updateSelectedIncident(payload));
      const filters: ApiIncidentManageFilters = {
        keyword: '',
        limit: pageLimit,
        offset: 1,
      };
      dispatch(fetchIncidents(filters));
      props.handleEditModal(false);
      //dispatch(updateIncident(putValue));
      //navigate(-1);
    }
  };

  const combineProps: IncidentDetailsProps = {
    form,
    loading,
    confirmModal,
    selectIncident,
    handleArchive,
    handleEditModal,
    formStatus,
    showModal: () => setConfirmModal(!confirmModal),
    onSubmit,
  };

  return <IncidentDetailsView {...combineProps} />;
};

export default IncidentDetails;
